export default [
    {
        path: '',
        component: () => import('../views/comeback/index'),
        meta: {
            requiresAuth: true,
            title: 'Отдел возврата',
            activeSideIcon:'#icon-comeback',
        },
        children: [
            {
                path: '/(uk/|ru/)?/comeback/index',
                name: 'ComebackDrivers',
                component: () => import('../views/comeback/tables/drivers'),
                meta: {
                    requiresAuth: true,
                    title: 'Активация новых водителей',
                    activeSideIcon:'#icon-comeback',
                },
            }, {
                path: '/(uk/|ru/)?/comeback/analytics',
                name: 'ComebackAnalytics',
                component: () => import('../views/comeback/tables/analytics'),
                meta: {
                    requiresAuth: true,
                    title: 'Аналитика',
                    activeSideIcon:'#icon-comeback',
                },
            }
        ]
    },
]
